import { Point } from 'pixi.js-legacy';
export class DragOptions {
    constructor() {
        this.interactive = true;
        this.buttonMode = true;
        this.bringToFront = false;
        this.priority = 0;
        this.dragStart = () => { };
        this.dragStop = () => { };
        this.dragUpdate = () => { };
    }
}
export class DragManager {
    constructor() {
        this.draggables = [];
        this.allowDrag = true;
    }
    static getInstance() {
        if (!this._instance) {
            this._instance = new DragManager();
        }
        return this._instance;
    }
    destroy() {
        DragManager._instance = undefined;
    }
    addDraggable(obj, options = new DragOptions()) {
        if (!this.allowDrag) {
            return;
        }
        obj.interactive = options.interactive;
        obj.buttonMode = options.buttonMode;
        obj.bringToFront = options.bringToFront;
        obj.priority = options.priority;
        obj.dragStop = options.dragStop;
        obj.dragUpdate = options.dragUpdate;
        obj.dragStart = options.dragStart;
        obj.draggable = true;
        obj
            .on('mousedown', this.onDragStart.bind(this))
            .on('touchstart', this.onDragStart.bind(this))
            .on('mouseup', this.onDragEnd.bind(this))
            .on('mouseupoutside', this.onDragEnd.bind(this))
            .on('touchend', this.onDragEnd.bind(this))
            .on('touchendoutside', this.onDragEnd.bind(this))
            .on('mousemove', this.onDragMove.bind(this))
            .on('touchmove', this.onDragMove.bind(this));
        this.draggables.push(obj);
    }
    stopAllDragging() {
        this.onDragEnd();
    }
    onDragStart(event) {
        if (!event.target.draggable) {
            return;
        }
        if (this.target) {
            if (event.target.priority < this.target.priority) {
                return;
            }
        }
        this.data = event.data;
        this.target = event.target;
        if (this.target.bringToFront) {
            this.bringToFront(this.target);
        }
        this.target.dragging = true;
        this.mousePressPoint = new Point();
        this.mousePressPoint.x =
            this.data.getLocalPosition(this.target.parent).x - this.target.x;
        this.mousePressPoint.y =
            this.data.getLocalPosition(this.target.parent).y - this.target.y;
        this.target.dragStart();
        this.globalDragStartCallback(this.target);
    }
    onDragEnd() {
        if (this.target != null) {
            this.target.dragStop();
            this.globalDragStopCallback(this.target);
        }
        this.data = null;
        this.target = null;
        this.mousePressPoint = null;
    }
    onDragMove() {
        if (!this.target) {
            return;
        }
        if (this.target.dragging) {
            const pos = this.data.getLocalPosition(this.target.parent);
            this.target.x = pos.x - this.mousePressPoint.x;
            this.target.y = pos.y - this.mousePressPoint.y;
            this.target.dragUpdate();
            this.globalDragCallback(this.target);
        }
    }
    bringToFront(target) {
        if (target.parent) {
            const parent = target.parent;
            parent.removeChild(target);
            parent.addChild(target);
        }
    }
}
